/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchUserResponseItem } from './search-user-response-item';


export interface SearchUserResponseItemPagedList { 
    totalCount?: number;
    items?: Array<SearchUserResponseItem> | null;
}

